import { Component, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';

@Component({
  selector:
    '[formGroup] section-batch-remittance, [formGroupName] section-batch-remittance',
  templateUrl: './batch-remittance.component.html',
})
export class BatchRemittanceComponent implements OnInit {
  public batchFrom: UntypedFormGroup;

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.batchFrom = this.controlContainer.control as UntypedFormGroup;
  }
}
